import FieldRuleResolver from "../../utils/field-rule-resolver";

Packlab.Mixin.register('field-rule-resolver', {
    methods: {
        resolveFieldRule(ruleset, ruleType, object, field, values) {
            const fieldRuleResolver = new FieldRuleResolver(ruleset, values);
            return fieldRuleResolver.resolve(ruleType, object, field);
        }
    }
});